// import  
// To be changed
// import Tables from "views/Dashboard/Tables.js";
import {
  DocumentIcon,
  HomeIcon,
  PersonIcon,
  ProfileIcon,
} from "components/Icons/Icons";
import SignInCover from "views/Authentication/SignIn/SignInCover.js";

// dashboard imports
import Default from "views/Dashboard/Default";
import NotulenDetail from "views/Dashboard/NotulenDetail";
import Changelog from "views/Dashboard/Changelog";
import SignUpCover from "views/Authentication/SignUp/SignUpCover";

import Profile from "./views/Dashboard/Profile";
import {SettingsIcon} from "@chakra-ui/icons";
import Subscription from "./views/Dashboard/Subscription";
import DefaultRefactor from "./views/Dashboard/DefaultRefactor";
import RealtimeTranscribe from "./views/Dashboard/RealtimeTranscribe";


const dashRoutes = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: <HomeIcon color="inherit" />,
    authIcon: <HomeIcon color="inherit" />,
    collapse: true,
    items: [
      {
        name: "Notulen",
        path: "/dashboard/notulen",
        component: DefaultRefactor,
        layout: "/admin",
      },
      {
        name: "Changelog",
        path: "/dashboard/changelog",
        component: Changelog,
        layout: "/admin",
      },
      {
        name: "Live Notuleren",
        path: "/dashboard/live-notuleren/:id",
        component: RealtimeTranscribe,
        layout: "/admin",
      },
      {
        name: "Detail",
        path: "/dashboard/detail",
        component: NotulenDetail,
        layout: "/admin",
      }
    ],
  },
  {
    name: "Account",
    path: "/dashboard",
    icon: <ProfileIcon color="inherit" />,
    authIcon: <ProfileIcon color="inherit" />,
    collapse: true,
    items: [
      {
        name: "Instellingen",
        authIcon: <SettingsIcon color="inherit" />,
        path: "/dashboard/settings",
        component: Profile,
        layout: "/admin",
      },
      {
        name: "Subscription",
        authIcon: <SettingsIcon color="inherit" />,
        path: "/dashboard/subscription",
        component: Subscription,
        layout: "/admin",
      }
    ]
  },
  {
    name: "Authentication",
    path: "/authentication",
    icon: <PersonIcon color="var(--title-color)"/>,
    collapse: true,
    items: [
      {
        name: "Sign In",
        path: "/authentication/sign-in",
        collapse: true,
        authIcon: <DocumentIcon color="var(--title-color)"/>,
        items: [
          {
            name: "Cover",
            component: SignInCover,
            path: "/sign-in",
            layout: "/auth",
          },
          {
            name: "Cover",
            component: SignUpCover,
            path: "/sign-up",
            layout: "/auth",
          },
        ],
      },
    ],
  }
];

export default dashRoutes;
